import { createAction } from '@reduxjs/toolkit';
export const FETCH_MESSAGE = 'FETCH_MESSAGE';
export const fetchMessageAction = createAction(FETCH_MESSAGE, (messageSessionId) => ({
  payload: { messageSessionId }
}));